import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty, omit, toArray, toInteger, toPlainObject, values } from 'lodash';

import HowItWorksComponent from '../../../components/HowItWorksComponent';
import { hasCashback, hasCoupon } from '../../../services/partner/utils';
import GridDirectoryComponent from './GridDirectoryComponent';
import FilterComponent from './filter/FilterComponent';
import ABCBookComponent from './ABCBookComponent';
import meaService from '../../../services/mea';
import {
    sortOnOrder,
    sortOnCreationDate,
    sortOnCashback,
    sortOnName,
    sortOnNbCoupon,
    filterOnCategory,
    filterOnFirstLetter
} from '../../../services/partner/selector';
import {
    FILTER_PARTNER_ON_CATEGORY,
    FILTER_PARTNER_ON_FIRST_LETTER,
    SORT_PARTNER_ON_NAME,
    SORT_PARTNER_ON_CASHBACK,
    SORT_PARTNER_ON_ORDER,
    SORT_PARTNER_ON_CREATION_DATE,
    SORT_PARTNER_ON_NB_COUPON
} from '../../../services/filter/constants';

import './DirectoryPage.scss';

class DirectoryPage extends React.Component {
    componentDidMount() {
        if (toInteger(this.props.categoryId)) {
            // fetch les meas bandeau si on a une catégorie selectionnée
            this.props.dispatch(
                meaService.actions.fetchMeasIfNeeded(meaService.constants.BANDEAU_RUBRIQUE)
            );
        }
    }

    sortPartners = (sorter, partners) =>
        sorter
            ? partners.sort(
                  (type => {
                      switch (type) {
                          case SORT_PARTNER_ON_NAME:
                              return sortOnName;
                          case SORT_PARTNER_ON_CASHBACK:
                              return sortOnCashback;
                          case SORT_PARTNER_ON_ORDER:
                              return sortOnOrder;
                          case SORT_PARTNER_ON_CREATION_DATE:
                              return sortOnCreationDate;
                          case SORT_PARTNER_ON_NB_COUPON:
                              return sortOnNbCoupon;
                          default:
                              return () => 1;
                      }
                  })(sorter.type)
              )
            : partners;

    filterPartners = (filter, partners) =>
        filter
            ? partners.filter(p =>
                  (type => {
                      switch (type) {
                          case FILTER_PARTNER_ON_FIRST_LETTER:
                              return filterOnFirstLetter;
                          case FILTER_PARTNER_ON_CATEGORY:
                              return filterOnCategory;
                          default:
                              return () => () => true;
                      }
                  })(filter.type)(filter.args)(p)
              )
            : partners;

    // Only parners with coupon id directory codepromo or cashbak if directory cb
    filterActivity = (partners, isCodePromo) =>
        isCodePromo
            ? partners.filter(partner => hasCoupon(partner))
            : partners.filter(partner => hasCashback(partner));

    render() {
        const {
            partners,
            filter = {},
            sorter = {},
            fetching,
            categories,
            categoryId,
            letter,
            isCodePromo = false,
            Breadcrumb,
            i18nPage
        } = this.props;
        const category = toPlainObject(categories[categoryId]);
        const filteredPartners = this.filterPartners(filter, partners);
        const partnerList = this.sortPartners(
            sorter,
            this.filterActivity(filteredPartners, isCodePromo)
        );

        return (
            <div className="flex-container-v">
                {Breadcrumb && <Breadcrumb />}

                <main className="conteneur conteneur-mobile" id="p-annuaire">
                    <h1>
                        {isEmpty(category) && !letter
                            ? i18nPage.MOST_POPULAR.PAGE_TITLE
                            : category.label}
                    </h1>
                    {letter && <h1>{i18nPage.A_Z.PAGE_TITLE}</h1>}
                    <FilterComponent
                        partners={partnerList}
                        categoryId={!isEmpty(category) ? category.id : -1}
                        categories={values(categories)}
                        isCodePromo={isCodePromo}
                    />
                    <ABCBookComponent isCodePromo={isCodePromo} letter={letter} />
                    <GridDirectoryComponent
                        partners={partnerList}
                        fetching={fetching}
                        isCodePromo={isCodePromo}
                    />
                </main>
                <HowItWorksComponent topShadow showTitle cssClass="conteneur conteneur-mobile" />
            </div>
        );
    }
}

DirectoryPage.propTypes = {
    categoryId: PropTypes.number,
    letter: PropTypes.string,
    isCodePromo: PropTypes.bool,
    partners: PropTypes.array.isRequired,
    fetching: PropTypes.bool.isRequired,
    categories: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    const category = Number((/-(\d*)$/.exec(window.location.pathname) || [])[1]) || null;
    const partners = toArray(state.partner.partners).filter(p =>
        category ? p.categoriesIds.indexOf(category) > -1 : true
    );

    return {
        partners,
        fetching: state.partner.fetching,
        categories: toPlainObject(omit(state.category.categories, 'loading')),
        filter: (state.filters.directory || {}).filter,
        sorter: (state.filters.directory || {}).sorter,
        i18nPage: state.i18n.page.DIRECTORY
    };
};

export default withRouter(connect(mapStateToProps)(DirectoryPage));



// WEBPACK FOOTER //
// ./src/components/pages/directory/DirectoryPage.js